import { createContext, useContext, useEffect, useState } from "react";
import { NotificationManager } from "../notification/NotificationManager";
import { KarmaPoolAuthPingManager } from "./KarmaPoolAuthPingManager";
import { KarmaPoolCauseManager } from "./KarmaPoolCauseManager";
import { KarmaPoolContentPlayingManager } from "./KarmaPoolContentPlayingManager";
import { KarmaPoolCycleManager } from "./KarmaPoolCycleManager";
import { KarmaPoolDonationProofManager } from "./KarmaPoolDonationProofManager";
import { KarmaPoolNoteManager } from "./KarmaPoolNoteManager";
import { KarmaPoolNoteTagManager } from "./KarmaPoolNoteTagManager";
import { KarmaPoolProfileManager } from "./KarmaPoolProfileManager";
import { KarmaPoolProfilePictureManager } from "./KarmaPoolProfilePictureManager";
import { KarmaPoolStripePaymentManager } from "./KarmaPoolStripePaymentManager";
import { KarmaPoolSubscriptionDetailsManager } from "./KarmaPoolSubscriptionDetailsManager";
import { KarmaPoolUserManager } from "./KarmaPoolUserManager";

const KarmaPoolContext = createContext();

export const KarmaPoolProvider = ({ children }) => {

    const [env, setEnv] = useState(() => {
        console.log("env state: " + process.env.NODE_ENV);
        return process.env.NODE_ENV === "development" ? "dev" : "prod";
    });

    const [local, setLocal] = useState(() => {
        const local = JSON.parse(sessionStorage.getItem("local"));
        console.log("local state: " + local);
        return local ? local : { cycle: {}, pool: {}, causes: [], subscriptionDetails: { loading: true, giftedMember: false } };
    });

    useEffect(() => {
        refresh();
    }, []);

    let cycleManager = KarmaPoolCycleManager(local, setLocal, getURLBasePath);
    let userManager = KarmaPoolUserManager(local, setLocal, getURLBasePath);
    let causeManager = KarmaPoolCauseManager(local, setLocal, refresh, getURLBasePath);
    let donationProofManager = KarmaPoolDonationProofManager(local, setLocal, refresh, getURLBasePath);
    let notificationManager = NotificationManager(setLocal, getURLBasePath);
    let noteManager = KarmaPoolNoteManager(local, setLocal, refresh, getURLBasePath);
    let profileManager = KarmaPoolProfileManager(local, setLocal, getURLBasePath);
    let tagManager = KarmaPoolNoteTagManager(local, setLocal, getURLBasePath);
    let paymentManager = KarmaPoolStripePaymentManager(local, setLocal, getURLBasePath);
    let profilePictureManager = KarmaPoolProfilePictureManager(local, setLocal, getURLBasePath);
    let authPingManager = KarmaPoolAuthPingManager(local, setLocal, getURLBasePath);
    let subscriptionDetailsManager = KarmaPoolSubscriptionDetailsManager(local, setLocal, getURLBasePath);
    let contentPlayingManager = KarmaPoolContentPlayingManager();

    function refresh() {
        cycleManager.refresh();
        userManager.refresh();
        causeManager.refresh();
        RefreshPool();
    }

    function getURLBasePath() {
        return env === "dev" ? "http://localhost:8080/rep/v1/" : "https://karmatic.com/rep/v1/";
    }

    function getURLBaseAuthPath() {
        return env === "dev" ? "http://localhost:8081/karma-id/api/" : "https://karmatic.com/karma-id/api/";
    }

    function RefreshPool() {
        fetch(getURLBasePath() + 'pool')
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
                // replace pool on local as object
                setLocal(prevValue => {
                    return { ...prevValue, pool: data };
                });

                localStorage.setItem("local.pool", JSON.stringify(data));
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    useEffect(() => {
        console.log("local updated, persist state");
        sessionStorage.setItem("local", JSON.stringify(local));
    }, [local]);

    return (
        <KarmaPoolContext.Provider value={{
            local, setLocal, refresh,
            causeManager, donationProofManager, notificationManager, 
            noteManager, profileManager, tagManager, paymentManager, 
            profilePictureManager, authPingManager, subscriptionDetailsManager, 
            contentPlayingManager,
            getURLBasePath, 
            getURLBaseAuthPath
        }}>
            {children}
        </KarmaPoolContext.Provider>
    );
}

export const useKarmaPoolContext = () => useContext(KarmaPoolContext)